import { createSelector } from 'reselect';
import getDramaStatusText from '../utils/getDramaStatusText';

export const dramaIdSelector = (_, props) => Number.parseInt(props.match.params.dramaId);

export const videoIdSelector = (_, props) => Number.parseInt(props.match.params.videoId);

export const videoTypeSelector = (_, props) => props.match.params.videoType;

export const isEpsSelector = (_, props) => props.match.params?.videoType === 'eps';

const isBtsSelector = (_, props) => props.match.params.videoType === 'behind';

export const categoryEntitiesSelector = (state) => state.entities.categories;

const allDramaInfoByIdSelector = (state) => state.entities.dramaInfo.byId;

export const createDramaInfoSelector = () =>
  createSelector([allDramaInfoByIdSelector, dramaIdSelector], (allDramaInfoById, dramaId) => {
    return allDramaInfoById[dramaId];
  });

export const createDramaCategorySelector = () =>
  createSelector([createDramaInfoSelector(), categoryEntitiesSelector], (dramaInfo, categories) => {
    return categories[dramaInfo?.area_id]?.name?.default ?? '';
  });

export const createDramaStatusTextFromDramaInfoSelector = () =>
  createSelector(createDramaInfoSelector(), (dramaInfo) => {
    return getDramaStatusText(dramaInfo.drama_status, dramaInfo.current_eps);
  });

export const createEpsInfoSelector = () =>
  createSelector([createDramaInfoSelector()], (dramaInfo) => dramaInfo?.eps_info);

export const createBtsInfoSelector = () =>
  createSelector([createDramaInfoSelector()], (dramaInfo) => dramaInfo?.behind_the_scenes);

export const createCurrentEpsInfoSelector = () =>
  createSelector([createEpsInfoSelector(), videoIdSelector, isEpsSelector], (epsInfo, videoId, isEps) => {
    if (isEps && Array.isArray(epsInfo)) {
      return epsInfo.find((item) => item.number == videoId);
    }
  });

export const createCurrentBtsInfoSelector = () =>
  createSelector([createBtsInfoSelector(), videoIdSelector, isBtsSelector], (btsInfo, videoId, isBts) => {
    if (isBts && Array.isArray(btsInfo)) {
      return btsInfo.find((item) => item.id == videoId);
    }
  });

export const createVideoTitleSelector = () =>
  createSelector(
    [videoTypeSelector, createCurrentEpsInfoSelector(), createCurrentBtsInfoSelector()],
    (videoType, currentEpsInfo, currentBtsInfo) => {
      switch (videoType) {
        case 'eps': {
          return currentEpsInfo?.title ?? '';
        }
        case 'behind': {
          return currentBtsInfo?.title ?? '';
        }
        default: {
          return '';
        }
      }
    }
  );

export const createVideoNameSelector = () =>
  createSelector(
    [createDramaInfoSelector(), videoTypeSelector, createCurrentBtsInfoSelector()],
    (dramaInfo, videoType, currentBtsInfo) => {
      switch (videoType) {
        case 'eps': {
          return dramaInfo.drama_name;
        }
        case 'behind': {
          return currentBtsInfo?.title ?? '';
        }
      }
    }
  );

export const createSourcePartsSelector = () =>
  createSelector([createCurrentBtsInfoSelector(), isBtsSelector], (currentBtsInfo, isBts) => {
    if (isBts && currentBtsInfo) {
      return {
        links: currentBtsInfo.related_media_source_parts,
        sourceType: currentBtsInfo.source_type,
      };
    }
  });

const allDramaSeoInfoByIdSelector = (state) => state.entities.dramaSeoInfo.byId;

const createDramaSeoInfoSelector = () =>
  createSelector([allDramaSeoInfoByIdSelector, dramaIdSelector], (allDramaSeoInfoById, dramaId) => allDramaSeoInfoById[dramaId]);

export const createCurrentEpsSeoInfoSelector = () =>
  createSelector([createDramaSeoInfoSelector(), isEpsSelector, videoIdSelector], (dramaSeoInfo, isEps, videoId) => {
    if (Array.isArray(dramaSeoInfo) && isEps) {
      return dramaSeoInfo.find((item) => item.eps == videoId);
    }
  });

export const createDramaDescriptionSelector = () =>
  createSelector([createDramaInfoSelector(), createCurrentEpsSeoInfoSelector()], (dramaInfo, currentDramaSeoInfo) => {
    return currentDramaSeoInfo?.description ?? dramaInfo.introduction;
  });
